/**
 * customNutrition.js — Rê Leve
 *
 * Permite adicionar alimentos personalizados sem precisar mexer na base
 * padrão (TACO/USDA). Persistidos em localStorage. Quando o backend ativar,
 * sincronizam pra tabela custom_foods.
 */

import { publish, EVT } from './liveSyncEngine';

const LS_KEY = 'releve.nutrition.custom';

export function getCustomFoods() {
  if (typeof window === 'undefined') return [];
  try {
    return JSON.parse(localStorage.getItem(LS_KEY) || '[]');
  } catch { return []; }
}

export function addCustomFood({ name, aliases = [], kcal = 0, protein = 0, carb = 0, fat = 0, fiber = 0, group = 'outro' }) {
  if (!name?.trim()) throw new Error('Nome é obrigatório');
  const list = getCustomFoods();
  const newF = {
    name: name.trim(),
    aliases: typeof aliases === 'string' ? aliases.split(',').map(s => s.trim()).filter(Boolean) : aliases,
    kcal: Number(kcal) || 0,
    protein: Number(protein) || 0,
    carb: Number(carb) || 0,
    fat: Number(fat) || 0,
    fiber: Number(fiber) || 0,
    group: group || 'outro',
    custom: true,
    createdAt: new Date().toISOString(),
  };
  const next = [newF, ...list];
  try { localStorage.setItem(LS_KEY, JSON.stringify(next)); } catch {}
  publish(EVT.KNOWLEDGE_RAG_UPDATED, { action: 'nutrition.add', name: newF.name });
  return newF;
}

export function deleteCustomFood(name) {
  const list = getCustomFoods();
  const next = list.filter(f => f.name !== name);
  try { localStorage.setItem(LS_KEY, JSON.stringify(next)); } catch {}
  publish(EVT.KNOWLEDGE_RAG_UPDATED, { action: 'nutrition.delete', name });
}
